import { render, staticRenderFns } from "./LoanAgingSummary.vue?vue&type=template&id=8084c98a"
import script from "./LoanAgingSummary.vue?vue&type=script&lang=js"
export * from "./LoanAgingSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports